import { bootLog } from '@tools/bootLog';
import './BootLoadingScreen.css';

interface BootLoadingScreenProps {
  scope?: string;
}

const BootLoadingScreen = ({ scope = 'app' }: BootLoadingScreenProps) => {
  bootLog('PersistGate loading rendered', { scope });

  return (
    <div
      className="boot-loading-screen"
      data-scope={scope}
      data-testid="boot-loading-screen"
      role="status"
      aria-live="polite"
    >
      <span className="boot-loading-screen__spinner" aria-hidden="true" />
      <span>Cargando aplicación...</span>
    </div>
  );
};

export default BootLoadingScreen;
